import React, { useEffect, useState, useRef } from 'react'
import { TabContext, TabList, TabPanel } from '@material-ui/lab'
import { Box, Checkbox, FormControlLabel, Radio, Tab, Tooltip, FormHelperText, RadioGroup, FormControl, FormLabel } from '@mui/material'
import { useDispatch, useSelector } from 'react-redux';
import { getcontracts } from '../../pages/bookingConfirmation/thunks/getcontracts';
import moment from 'moment';
import SpinnerLoader from '../../pages/bookingConfirmation/Utils/spinner';
import { useHistory } from 'react-router-dom';
import { getClassData } from '../thunks/getClassData';
import { setClassData, setSelectedTarifData } from '../AppStore/ActionCreator/commonDataAction';
import { putBulkUpdate } from '../thunks/putBulkUpdate';
import swal from 'sweetalert';
import { upsertNewTariff } from '../thunks/upsertNewTariff';
import { TextField } from '@material-ui/core';
import { useLocation } from "react-router-dom";
import { getOneTarif } from '../thunks/getOneTarif';
import { showDetailedErrorSwal } from '../../components/common components/showErrorSwal';

function useQuery() {
    return new URLSearchParams(useLocation().search);
}
const NewTariff = () => {
    const query = useQuery();
    const history = useHistory();
    const URLTarifKey = query.get("tariff");
    const isEmpty = (obj) => Object.keys(obj).length === 0;
    const [classApiCallLoader, setClassApiCallLoader] = useState(false)
    const [classesArray, setClassesArray] = useState([])
    const [value, setValue] = React.useState('1');
    // const tarifDetails = useSelector((state)=>state.commonDataReducer.tarifDetail)
    const dispatch = useDispatch();
    const [tarif, setTarif] = useState({})
    const [updateLoader, setUpdateLoader] = useState(false)
    const [createNew, setCreateNew] = useState(false)
    const [disableEdit, setDisableEdit] = useState(()=>!createNew)
    const [loader, setLoader] = useState(false);
    const [tariffArray, setTariffArray] = useState([])
    const [currentTariffIndex, setCurrentTariffIndex] = useState(0)

    const [allTextFields, setAllTextFields] = React.useState({
        "carrier": true,
        "origins": true,
        "destinations": true,
        "note": true,
        "contractOwner": true,
        "maximumFeeCCAmoutByCarrier": true,
        "ccFeesForTBMerchant": true,
        "pseudoCityCodes": true,
        "tarifPCC_FUN": true,
        "tarifPCC_SKY": true,
        "tarifPCC_TC": true,
        "tarifPCC_DFW": true,
    })

    // useEffect(()=>{
    //     setTarif({...tarifDetails})
    // },[tarifDetails])
    const searchAllV2Result = useSelector((state)=>state.commonDataReducer.searchAllV2Result);
    const tarifKeyss = useSelector((state)=>state.commonDataReducer.tariffKeys);
    
    useEffect(()=>{
        if(searchAllV2Result){
            setTariffArray(searchAllV2Result)
        }

    },[searchAllV2Result])
    useEffect(() => {
            if(URLTarifKey){
                setCreateNew(false)
                setDisableEdit(true)
                getData()
            }else {
                setCreateNew(true)
                setDisableEdit(false)
            }
        }, [URLTarifKey])
    
        const getData = async () => {
            setLoader(true)
            let tarifDetails = await getOneTarif(URLTarifKey);
            if (tarifDetails.data) {
                setTarif(tarifDetails.data);
            }
            let currIndex= tarifKeyss?.findIndex((item) => item == URLTarifKey)
            setCurrentTariffIndex(currIndex)
            setLoader(false)
        }

    const editAll = () => {
        setDisableEdit(!disableEdit)
    }

    const handleChange = async (event, newValue) => {
        setValue(newValue)
        if(newValue == "2" && !createNew){
            setClassApiCallLoader(true)
            const classes = await getcontracts({"tarifKey": tarif?.tarifKey })
            setClassApiCallLoader(false)
            setClassesArray(classes?.tarifs[0]?.classes)
        }
        
    };

    const cancelClick = () => {
        if(createNew){
            history.push('/Newcontractlist')
        }else{
            setDisableEdit(true);
            // setTarif({...tarifDetails})
        }
    }

    useEffect(()=>{
        window. scrollTo({ top: 0, left: 0})
    },[])

    const getClasses = (classes = "") => {
        const arr = classes.split(",");
        let addEllipsis = false;
        if(arr.length > 3){
            arr.length = 3;
            addEllipsis = true;
        }
        const returnValue =  arr.join(",");
        return addEllipsis ? `${returnValue}...` : returnValue;
    }

    const openClass = async (id, tarif) => {
        // let res = await getClassData(id?.clasKey)
        // let tarifData = { ...id, ...tarif }
        // dispatch(setSelectedTarifData(tarifData))
        // dispatch(setClassData(res))
        history.push(`/newClass?tariff=${tarif?.tarifKey}+&class=${id?.clasKey}`)
    }

    const commonOnChange = (key, newValue) => {
        let copyMandatoryFields = { ...mandatoryFields };
        if(copyMandatoryFields[key]){
            copyMandatoryFields[key] = false;
            setMandatory({ ...copyMandatoryFields })
        }
        if(allTextFields[key]){
            newValue = newValue?.toUpperCase()
        }
        setTarif({ ...tarif, [key]: newValue });
    }

    const handleContractType = (type)=>{
        if(type == "airOnly"){
            setTarif({ ...tarif, landFare: "0", cruiseFare:"0" });
        }else if(type == "land"){
            setTarif({ ...tarif, landFare: "1", cruiseFare:"0" });
        }else if(type == "cruise"){
            setTarif({ ...tarif, landFare: "0", cruiseFare:"1" });
        }
        let copyMandatoryFields = { ...mandatoryFields };
        copyMandatoryFields['landFare'] =  false ;
        copyMandatoryFields['cruiseFare'] =  false ;
        setMandatory({ ...copyMandatoryFields })
    }

    const removeItem = (array, indexToRemove) => {
        return array.filter((item, index) => index !== indexToRemove);
    };

    const saveTariff = async() => {
        setUpdateLoader(true)
        let temp = {...tarif}
        
        const payload = {
            "tarifKeys": tarif?.tarifKey ? [tarif?.tarifKey] : undefined,
            "tarifData" : temp
        }
        const finalTarifData = filterObject(convertPropertiesToArray(payload)?.tarifData, keysToKeep);
        const finalPayload = [{...finalTarifData, "tarifKey": tarif?.tarifKey ? tarif?.tarifKey : undefined}]
        
        // Check if all mandatory fields are entered;
        let copyMandatoryFields = {...mandatoryFields};
        Object.keys(copyMandatoryFields).forEach((field) => {
            if(field == "isBrandedFare"){
                copyMandatoryFields[field] = tarif.hasOwnProperty('isBrandedFare') ? false : true;
            }else{
                copyMandatoryFields[field] = tarif[field]?.length && tarif[field]?.length > 0 ? false : true;
            }
        });
        setMandatory({...copyMandatoryFields})
        const missingFields = Object.keys(copyMandatoryFields).filter((field) => copyMandatoryFields[field]);

        if (missingFields.length > 0) {
            setUpdateLoader(false);
            swal({
                text: "Please fill all the required fields.",
                icon: "error",
                button: "Close",
                timer: 2000,
            })
            return;
        }
        if (tarif?.mappedOpeartingAirlines == undefined || tarif?.mappedOpeartingAirlines?.length == 0) {
            finalPayload[0].mappedOpeartingAirlines = [null];
        }
        if (tarif?.marketingAirline == undefined || tarif?.marketingAirline?.length == 0) {
            finalPayload[0].marketingAirline = [null];
        }
        const bulkUpdateResponse = await upsertNewTariff(finalPayload)
        setUpdateLoader(false)
        if (bulkUpdateResponse?.status == "Success") {
            swal({
                text: createNew ? "Tariff created successfully!" : "Tariff updated successfully!",
                icon: "success",
                button: "Close",
                timer: 2000,
            })
            let key = bulkUpdateResponse?.keys?.[0];
            if (key) {
                history.push(`/newTariff?tariff=${key}`);
            }
        } else {
            // swal({
            //     text: bulkUpdateResponse?.message,
            //     icon: "error",
            //     button: "Close",
            //     timer: 2000,
            // })
            showDetailedErrorSwal({
                message: bulkUpdateResponse?.message,
                errorDetails: bulkUpdateResponse?.errorDetails
            });
        }
    }

    const createNewTariff = () => {
        console.log('New Tariff is created!')
    }

    const createTariffAndNewClass = () => {
        console.log('tariff created! ',tarif);
        createNewTariff();
        // dispatch(setClassData([]));
        history.push('/newClass');
    }

    function convertPropertiesToArray(jsonData) {
        if (jsonData?.tarifData?.tarifKeys) {
            delete jsonData.tarifData.tarifKeys;
        }
    
        // if (jsonData.tarifData.origins !== null && jsonData.tarifData.origins !== undefined && !Array.isArray(jsonData.tarifData.origins)) {
        //     jsonData.tarifData.origins = [jsonData.tarifData.origins];
        // }
    
        // if (jsonData.tarifData.destinations !== null && jsonData.tarifData.destinations !== undefined && !Array.isArray(jsonData.tarifData.destinations)) {
        //     jsonData.tarifData.destinations = [jsonData.tarifData.destinations];
        // }
    
        if (jsonData.tarifData.marketingAirline !== null && jsonData.tarifData.marketingAirline !== undefined && !Array.isArray(jsonData.tarifData.marketingAirline)) {
            jsonData.tarifData.marketingAirline = [jsonData.tarifData.marketingAirline];
        }
    
        if (jsonData.tarifData.mappedOpeartingAirlines !== null && jsonData.tarifData.mappedOpeartingAirlines !== undefined && !Array.isArray(jsonData.tarifData.mappedOpeartingAirlines)) {
            jsonData.tarifData.mappedOpeartingAirlines = [jsonData.tarifData.mappedOpeartingAirlines];
        }
    
        return jsonData;
    }
    

    let keysToKeep = [
        "origins",
        "destinations",
        "marketingAirline",
        "mappedOpeartingAirlines",
        "maximumFeeCCBycarrierType",
        "maximumFeeCCAmoutByCarrier",
        "note",
        "ccFeesForTBMerchant",
        "landFare",
        "cruiseFare",
        "cabinType",
        "tripType",
        "isBrandedFare",
        "DFW",
        "funSun",
        "intairTransit",
        "skyLink",
        "sunquest",
        "network",
        "formsOfPayment",
        "notesIV",
        "carrier",
        "calculationBasis",
        "contractOwner",
        "disallowedAirports",
        "distributionChannels",
        "pseudoCityCodes",
        "passengerType",
        "routings",
        "skipRoutingCheck",
        "tarifPCC_DFW",
        "tarifPCC_FUN",
        "tarifPCC_SKY",
        "tarifPCC_TC",
        "isDisabled",
    ];

    let [mandatoryFields,setMandatory] = useState({
        "origins":false,
        "destinations":false,
        "cabinType":false,
        "tripType":false,
        "isBrandedFare":false,
        "carrier":false,
        "landFare":false,
        "cruiseFare":false,
    });

    let inputFields = [
        "carrier",
        "origins",
        "destinations",
        "marketingAirline",
        "mappedOpeartingAirlines",
        "notesIV",
        "note",
        "contractOwner",
        "maximumFeeCCAmoutByCarrier",
        "ccFeesForTBMerchant",
        "disallowedAirports",
        "routings",
        "pseudoCityCodes",
        "tarifPCC_FUN",
        "tarifPCC_SKY",
        "tarifPCC_TC",
        "tarifPCC_DFW"
    ]

    console.log("allData",tarif,mandatoryFields)
    function filterObject(obj, keys) {
        return keys.reduce((acc, key) => {
            if (obj.hasOwnProperty(key)) {
                acc[key] = obj[key];
            }
            return acc;
        }, {});
    }

    const addToArrayProperty = (obj, prop, value) => {
        if (Array.isArray(obj?.[prop])) {
          obj[prop].push(value);
        } else {
          obj[prop] = [value];
        }
        return obj[prop]
    }
    
    function formatToESTDate(dateString) {
        const date = new Date(dateString);
        const year = date.getUTCFullYear();
        const month = date.getUTCMonth();
        const day = date.getUTCDate();
        const monthNames = ["Jan", "Feb", "Mar", "Apr", "May", "Jun", "Jul", "Aug", "Sep", "Oct", "Nov", "Dec"];
        return `${day}-${monthNames[month]}-${year}`;
      }

    const currentTariffIndexRef = useRef(currentTariffIndex);
    const tariffArrayRef = useRef(tariffArray);
    const createNewRef = useRef(createNew);

    useEffect(() => {
        currentTariffIndexRef.current = currentTariffIndex;
        tariffArrayRef.current = tariffArray;
        createNewRef.current = createNew;
    }, [currentTariffIndex, tariffArray, createNew]);

    const handleNextClass = () => {
        const nextIndex = currentTariffIndexRef.current + 1;
        if (tariffArrayRef.current[nextIndex] && (!createNewRef.current)) {
            const nextTariffData = tariffArrayRef.current[nextIndex];
            const tarifKey = nextTariffData?.tarifKey;
            history.push(`/newTariff?tariff=${tarifKey}`);
        }
    };

    const handlePreviousClass = () => {
        const prevIndex = currentTariffIndexRef.current - 1;
        if (tariffArrayRef.current[prevIndex] && (!createNewRef.current)) {
            const prevTariffData = tariffArrayRef.current[prevIndex];
            const tarifKey = prevTariffData?.tarifKey;
            history.push(`/newTariff?tariff=${tarifKey}`);
        }
    };

    useEffect(() => {
        const handleKeyDown = (event) => {
            if (event.ctrlKey && event.key === "ArrowRight") {
                event.preventDefault();
                handleNextClass();
            } else if (event.ctrlKey && event.key === "ArrowLeft") {
                event.preventDefault();
                handlePreviousClass();
            }
        };

        window.addEventListener("keydown", handleKeyDown);
        return () => window.removeEventListener("keydown", handleKeyDown);
    }, []);

    const createDuplicate = async () => {
        setUpdateLoader(true)
        let temp = { ...tarif }

        const payload = {
            "tarifKeys": tarif?.tarifKey ? [tarif?.tarifKey] : undefined,
            "tarifData": temp
        }
        const finalTarifData = filterObject(convertPropertiesToArray(payload)?.tarifData, keysToKeep);
        const finalPayload = [{ ...finalTarifData, "tarifKey": undefined }]

        // Check if all mandatory fields are entered;
        let copyMandatoryFields = { ...mandatoryFields };
        Object.keys(copyMandatoryFields).forEach((field) => {
            if (field == "isBrandedFare") {
                copyMandatoryFields[field] = tarif.hasOwnProperty('isBrandedFare') ? false : true;
            } else {
                copyMandatoryFields[field] = tarif[field]?.length && tarif[field]?.length > 0 ? false : true;
            }
        });
        setMandatory({ ...copyMandatoryFields })
        const missingFields = Object.keys(copyMandatoryFields).filter((field) => copyMandatoryFields[field]);

        if (missingFields.length > 0) {
            setUpdateLoader(false);
            swal({
                text: "Please fill all the required fields.",
                icon: "error",
                button: "Close",
                timer: 2000,
            })
            return;
        }
        const bulkUpdateResponse = await upsertNewTariff(finalPayload)
        setUpdateLoader(false)
        if (bulkUpdateResponse?.status == "Success") {
            swal({
                text: "Tariff duplicated successfully!",
                icon: "success",
                button: "Close",
                timer: 2000,
            })
            let key = bulkUpdateResponse?.keys?.[0];
            if (key) {
                history.push(`/newTariff?tariff=${key}`);
            }
        } else {
            // swal({
            //     text: bulkUpdateResponse?.message,
            //     icon: "error",
            //     button: "Close",
            //     timer: 2000,
            // })
            showDetailedErrorSwal({
                message: bulkUpdateResponse?.message,
                errorDetails: bulkUpdateResponse?.errorDetails
            });
        }
    }


    return (

        <>
            {loader ?
            <div className="col-md-12 text-center mt-3">
                <SpinnerLoader /> 
            </div>
            :
        <>{(Object.keys(tarif).length || createNew) ? <div>
            <div className="cm-head-2">
                <div className={!createNew ? "d-flex justify-content-between":"d-flex justify-content-left"}>
                {/* {!createNew && <span style={{"fontSize":"1rem","color":"#0055b8","cursor":"pointer"}} onClick={()=>{history.push('/Newcontractlist')}}>{`<<- Back to Results`}</span>} */}
                    <div className='d-flex '>
                        <h5 className="">
                            {createNew ? 'Create Tariff' : disableEdit ?
                                <>
                                    Tariff Details
                                </>
                                :
                                <>
                                    Edit Tariff
                                </>
                            }

                        </h5>&nbsp;&nbsp;
                        {(!createNew && (disableEdit))&&<i className="fas fa-edit" style={{ "color": "#0055b8" }} onClick={editAll}></i>}
                        {/* {(!createNew) &&
                            <span title="Create a Duplicate Tariff">
                                <i class="fa-solid fa-copy" style={{ "color": "#0055b8", "cursor": "pointer", "marginLeft": "10px" }} onClick={() => createDuplicate()}></i>
                            </span>
                        } */}
                    </div>
                    
                    {/* <div className="classTopEdit"> */}
                        {/* <button className='classEditBtn' onClick={editAll}> */}
                           
                        {/* </button> */}
                    {/* </div> */}
                    {(!createNew) &&
                        <div>
                            Tariff: {tarif?.tarifKey}
                        </div>
                    }
                </div>
            </div>

            <div className="Tariff__Section">
                <div >
                    <div className="card Tariff__BorderB">
                        <div className="card-body">
                            <div className="row mt-4">
                                <div className="col-md-6 cm-col">

                                    <div className="row">
                                        <div className="col-md-6">
                                            {/* <label className="cm-head-label">Validating Carrier <span className='bd-errorMsg'>*</span></label> */}
                                            <TextField label='Validating Carrier'
                                                className="form-control cm-input autoCapitalise custom-disabled-field "
                                                placeholder="Enter validating carrier"
                                                value={tarif?.carrier}
                                                disabled={(!createNew)}
                                                onChange={(e)=>commonOnChange('carrier',e.target.value)}
                                                required={true}
                                            />
                                            {mandatoryFields?.carrier &&
                                                <div className='bd-errorMsg'>This field is required.</div>
                                            }
                                        </div>
                                        <div className="col-md-6">
                                            {/* <label className="cm-head-label">Origin <span className='bd-errorMsg'>*</span></label> */}

                                            <TextField label='Origin'
                                                className="form-control cm-input autoCapitalise custom-disabled-field "
                                                placeholder="Enter Origin ..."
                                                value={tarif?.origins}
                                                disabled={(!createNew)}
                                                onChange={(e)=>commonOnChange('origins',e.target.value)}
                                                required={true}
                                            />
                                            {mandatoryFields?.origins &&
                                                <div className='bd-errorMsg'>This field is required.</div>
                                            }
                                        </div>
                                    </div>
                                </div>
                                <div className="col-md-6 cm-col">
                                    <div className="row">
                                        
                                        <div className="col-md-6">
                                            {/* <label className="cm-head-label">Destination <span className='bd-errorMsg'>*</span></label> */}
                                            <TextField label='Destination'
                                                className="form-control cm-input autoCapitalise custom-disabled-field "
                                                placeholder="Enter Destination ..."
                                                value={tarif?.destinations}
                                                disabled={disableEdit}
                                                onChange={(e)=>commonOnChange('destinations',e.target.value)}
                                                required={true}
                                            />
                                            {mandatoryFields?.destinations &&
                                                <div className='bd-errorMsg'>This field is required.</div>
                                            }
                                        </div>
                                        <div className="col-md-6">
                                            <label className="cm-head-label">Trip Type <span className='bd-errorMsg'>*</span></label>
                                            <div className="cm-radio-inline custom-disabled-field">
                                                <FormControlLabel control={<Radio color="primary" checked={tarif?.tripType == "OW"} disabled={(!createNew)} onChange={() => commonOnChange('tripType', "OW")} />} label="One Way"
                                                />
                                                <FormControlLabel control={<Radio color="primary" checked={tarif?.tripType == "-OW"} disabled={(!createNew)} onChange={() => commonOnChange('tripType', "-OW")} />} label="Not One Way"
                                                />{" "}
                                            </div>
                                            {mandatoryFields?.tripType &&
                                                <div className='bd-errorMsg'>This field is required.</div>
                                            }
                                        </div>
                                    </div>
                                </div>

                            </div>

                            <div className="row">
                                {/* <div className="col-md-6">
                                    <div className="row">
                                        <div className="col-md-6 cm-col">
                                            <label className="cm-head-label">VIA</label>
                                            <TextField label='' className="form-control cm-input" placeholder="Enter VIA" />
                                        </div>
                                        <div className="col-md-6 cm-col">
                                            <label className="cm-head-label">Tariff Note</label>
                                            <TextField label=''
                                                className="form-control cm-input"
                                                placeholder="Enter Tariff Note"
                                            />
                                        </div>
                                    </div>

                                </div> */}

                                <div className="col-md-6">

                                    <div className="row">
                                        <div className="col-md-6 cm-col">
                                            <label className="cm-head-label">Cabin Type <span className='bd-errorMsg'>*</span></label>
                                            <div className="row custom-disabled-field">
                                                <div className="col-md-6  ">
                                                    <FormControlLabel
                                                        control={
                                                            <Checkbox
                                                                color="primary"
                                                                checked={tarif?.cabinType ? tarif?.cabinType.includes("Economy") : false}
                                                                disabled={disableEdit}
                                                                onChange={(e)=>commonOnChange('cabinType',tarif?.cabinType?.includes("Economy") ? removeItem([...tarif?.cabinType], tarif?.cabinType.indexOf('Economy')) : addToArrayProperty(tarif, 'cabinType', 'Economy'))}
                                                            />
                                                        }
                                                        label="Economy"
                                                    />
                                                </div>

                                                <div className="col-md-6 ">
                                                    <FormControlLabel
                                                        control={
                                                            <Checkbox
                                                                color="primary"
                                                                checked={tarif?.cabinType ? tarif?.cabinType.includes("PremiumEconomy") : false}
                                                                disabled={disableEdit}
                                                                onChange={(e)=>commonOnChange('cabinType',tarif?.cabinType?.includes("PremiumEconomy") ? removeItem([...tarif?.cabinType], tarif?.cabinType.indexOf('PremiumEconomy')) : addToArrayProperty(tarif, 'cabinType', 'PremiumEconomy'))}
                                                            />
                                                        }
                                                        label="Premium Economy"
                                                    />
                                                </div>
                                            </div>
                                            <div className="row custom-disabled-field">
                                                <div className="col-md-6 ">
                                                    <FormControlLabel
                                                        control={
                                                            <Checkbox
                                                                color="primary"
                                                                checked={tarif?.cabinType ? tarif?.cabinType.includes("Business") : false}
                                                                disabled={disableEdit}
                                                                onChange={(e) => commonOnChange('cabinType', tarif?.cabinType?.includes("Business") ? removeItem([...tarif?.cabinType], tarif?.cabinType.indexOf('Business')) : addToArrayProperty(tarif, 'cabinType', 'Business'))}
                                                            />
                                                        }
                                                        label="Business"
                                                    />
                                                </div>

                                                <div className="col-md-6 ">
                                                    <FormControlLabel
                                                        control={
                                                            <Checkbox
                                                                color="primary"
                                                                checked={tarif?.cabinType ? tarif?.cabinType.includes("First") : false}
                                                                disabled={disableEdit}
                                                                onChange={(e)=>commonOnChange('cabinType',tarif?.cabinType?.includes("First") ? removeItem([...tarif?.cabinType], tarif?.cabinType.indexOf('First')) : addToArrayProperty(tarif, 'cabinType', 'First'))}
                                                            />
                                                        }
                                                        label="First"
                                                    />
                                                </div>
                                            </div>
                                            {mandatoryFields?.cabinType &&
                                                <div className='bd-errorMsg'>This field is required.</div>
                                            }
                                        </div>
                                        <div className="col-md-6 cm-col">
                                            <label className="cm-head-label">Branded Fare <span className='bd-errorMsg'>*</span></label>
                                            <div className="cm-radio-inline custom-disabled-field">
                                                <FormControlLabel control={<Radio color="primary" checked={tarif?.isBrandedFare == 1} disabled={(!createNew)} onChange={()=>commonOnChange('isBrandedFare',1)}/>} label="Yes" />
                                                <FormControlLabel control={<Radio color="primary" checked={tarif?.isBrandedFare == 0} disabled={(!createNew)} onChange={()=>commonOnChange('isBrandedFare',0)}/>} label="No" />
                                            </div>
                                            {mandatoryFields?.isBrandedFare &&
                                                <div className='bd-errorMsg'>This field is required.</div>
                                            }
                                        </div>

                                    </div>

                                </div>
                                <div className="col-md-6">
                                    <div className="row">
                                        <div className="col-md-6 cm-col">
                                            <label className="cm-head-label">Contract Types <span className='bd-errorMsg'>*</span></label>
                                            <div className="cm-checkbox-inline custom-disabled-field">
                                                <FormControlLabel control={<Checkbox checked={(tarif?.cruiseFare == "0") && (tarif?.landFare == "1")} disabled={disableEdit} onChange={()=>handleContractType('land')}/>} label="Land" />
                                                <FormControlLabel control={<Checkbox color="primary" checked={((tarif?.landFare == "0") && (tarif?.cruiseFare == "0"))} disabled={disableEdit} onChange={()=>handleContractType('airOnly')}/>} label="Air Only" />
                                                <FormControlLabel control={<Checkbox color="primary" checked={(tarif?.landFare == "0") && (tarif?.cruiseFare == "1")} disabled={disableEdit} onChange={()=>handleContractType('cruise')}/>} label="Cruise" />

                                            </div>
                                            {(mandatoryFields?.landFare || mandatoryFields?.cruiseFare) &&
                                                <div className='bd-errorMsg'>This field is required.</div>
                                            }
                                        </div>

                                        <div className="col-md-6 cm-col">
                                            <label className="cm-head-label">Tariff Disabled </label>
                                            <div className="cm-radio-inline custom-disabled-field">
                                                <FormControlLabel control={<Radio color="primary" checked={tarif?.isDisabled} disabled={disableEdit} onChange={()=>commonOnChange('isDisabled',true)}/>} label="Yes" />
                                                <FormControlLabel control={<Radio color="primary" checked={tarif?.isDisabled == false} disabled={disableEdit} onChange={()=>commonOnChange('isDisabled',false)}/>} label="No" />
                                            </div>
                                        </div>
                                    </div>
                                </div>
                            </div>


                        </div>
                    </div>
                    <Box sx={{ width: '100%', typography: 'body1' }}>
                        <TabContext value={value}>
                            <Box sx={{ borderBottom: 20, borderColor: '#C9F7F5', background: '#fff' }}>
                                <TabList onChange={handleChange} aria-label="lab API tabs example">
                                    <Tab label="Tariff" value="1" />
                                    <Tab label="Classes" value="2" hidden={createNew}/>
                                </TabList>
                            </Box>
                            <TabPanel value="1" className='m-0 p-0'>
                                <div className="card Tariff__BorderB">
                                    <div className="card-body">
                                        <div className="row">
                                            <div className="col-md-3">
                                                <div className="cm-col">
                                                    {/* <label className="cm-head-label">Marketing Airline</label> */}
                                                    <TextField label='Marketing Airline' className="form-control cm-input autoCapitalise custom-disabled-field " type="text" value={tarif?.marketingAirline == "" || tarif?.marketingAirline?.includes("null") ? "" : tarif?.marketingAirline?.join()} disabled={disableEdit} onChange={(e) => commonOnChange('marketingAirline', e.target.value.toUpperCase().split(","))} />
                                                </div>
                                            </div>
                                            <div className="col-md-3">
                                                <div className="cm-col">
                                                    {/* <label className="cm-head-label">Operating Airline</label> */}
                                                    <TextField label='Operating Airline' className="form-control cm-input autoCapitalise custom-disabled-field " type="text" value={(tarif?.mappedOpeartingAirlines == "" || tarif?.mappedOpeartingAirlines?.includes("null")) ? "" : tarif?.mappedOpeartingAirlines?.join()} disabled={disableEdit} onChange={(e) => commonOnChange('mappedOpeartingAirlines', e.target.value.toUpperCase()?.split(","))} />
                                                </div>
                                            </div>

                                            {/* <div className="col-md-3">
                                                <div className="cm-col">
                                                    <label className="cm-head-label">Note Phase IV</label>
                                                    <TextField label='' className="form-control cm-input autoCapitalise custom-disabled-field " type="text" value={tarif?.notesIV} disabled={disableEdit} onChange={(e)=>commonOnChange('notesIV',e.target.value)}/>
                                                </div>
                                            </div>*/}
                                            <div className="col-md-3">
                                                <div className="cm-col">
                                                    {/* <label className="cm-head-label">Note </label> */}
                                                    <TextField label='Note' className="form-control cm-input autoCapitalise custom-disabled-field " type="text" value={tarif?.note} disabled={disableEdit} onChange={(e)=>commonOnChange('note',e.target.value)}/>
                                                </div>
                                            </div> 
                                            <div className="col-md-3">
                                                <div className="cm-col">
                                                    {/* <label className="cm-head-label">Contract Owner</label> */}
                                                    <TextField label='Contract Owner' className="form-control cm-input autoCapitalise custom-disabled-field " type="text" value={tarif?.contractOwner} disabled={disableEdit} onChange={(e)=>commonOnChange('contractOwner',e.target.value)} inputProps={{ maxLength: 20 }}/>
                                                </div>
                                            </div>
                                            {/* <div className="col-md-3">
                                                <div className="cm-col">
                                                    <label className="cm-head-label">PAX </label>
                                                    <FormControlLabel control={<Radio color="primary" checked={tarif?.passengerType == "SENIOR" ? true : false} disabled={disableEdit}/>} label="Senior" onChange={()=>commonOnChange('passengerType',"SENIOR")}/>
                                                    <FormControlLabel control={<Radio color="primary" checked={tarif?.passengerType == "ADULT" ? true : false} disabled={disableEdit}/>} label="Adult" onChange={()=>commonOnChange('passengerType',"ADULT")} />
                                                </div>
                                            </div> */}
                                        </div>
                                    </div>
                                </div>

                                <div className="card Tariff__BorderB">
                                    <div className="card-body">
                                        <div className="cm-head-2 mb-4">
                                            <div className="d-flex justify-content-between">
                                                <span>Characteristics</span>
                                            </div>
                                        </div>
                                        <div className="row">
                                            <div className="col-md-3">
                                                <div className="cm-col">
                                                    <label className="cm-head-label">FOP allowed (by Airline) for <br />Ticket issuance</label>
                                                    <div className="row custom-disabled-field">
                                                        <div className="col-md-6 ">
                                                            <FormControlLabel control={<Checkbox color="primary" checked={tarif?.formsOfPayment && tarif?.formsOfPayment?.includes("CHEQUE")} disabled={disableEdit}/>} label="Cheque" onChange={(e)=>commonOnChange('formsOfPayment',tarif?.formsOfPayment?.includes("CHEQUE") ? removeItem([...tarif?.formsOfPayment], tarif?.formsOfPayment.indexOf('CHEQUE')) : addToArrayProperty(tarif, 'formsOfPayment', 'CHEQUE'))}/>
                                                        </div>
                                                        <div className="col-md-6 ">
                                                            <FormControlLabel control={<Checkbox color="primary" checked={tarif?.formsOfPayment && tarif?.formsOfPayment?.includes("CREDITCARD")} disabled={disableEdit}/>} label="Credit Card" onChange={(e)=>commonOnChange('formsOfPayment',tarif?.formsOfPayment?.includes("CREDITCARD") ? removeItem([...tarif?.formsOfPayment], tarif?.formsOfPayment.indexOf('CREDITCARD')) : addToArrayProperty(tarif, 'formsOfPayment', 'CREDITCARD'))}/>
                                                        </div>
                                                        <div className="col-md-6 ">
                                                            <FormControlLabel control={<Checkbox color="primary" checked={tarif?.formsOfPayment && tarif?.formsOfPayment?.includes("CREDITINTERNAL")} disabled={disableEdit}/>} label="Credit Internal" onChange={(e)=>commonOnChange('formsOfPayment',tarif?.formsOfPayment?.includes("CREDITINTERNAL") ? removeItem([...tarif?.formsOfPayment], tarif?.formsOfPayment.indexOf('CREDITINTERNAL')) : addToArrayProperty(tarif, 'formsOfPayment', 'CREDITINTERNAL'))}/>
                                                        </div>
                                                    </div>

                                                </div>
                                            </div>
                                            <div className="col-md-3">
                                                <div className="cm-col">
                                                    <label className="cm-head-label">Maximum Authorised Amount on<br /> Airline as Merchant </label>
                                                    <div className="row custom-disabled-field">
                                                        <div className="col-md-4 ">
                                                            <FormControlLabel control={<Radio color="primary" checked={tarif?.maximumFeeCCBycarrierType == "Amount"}/>} label="($)" disabled={disableEdit} onChange={()=>commonOnChange('maximumFeeCCBycarrierType',"Amount")}/>
                                                            <FormControlLabel control={<Radio color="primary" checked={tarif?.maximumFeeCCBycarrierType == "Percentage"}/>} label="(%)" disabled={disableEdit} onChange={()=>commonOnChange('maximumFeeCCBycarrierType',"Percentage")}/>
                                                        </div>
                                                        <div className="col-md-8">
                                                            <TextField className="form-control cm-input autoCapitalise custom-disabled-field " placeholder="Enter Amount" value={tarif?.maximumFeeCCAmoutByCarrier}disabled={disableEdit} onChange={(e)=>commonOnChange('maximumFeeCCAmoutByCarrier',e.target.value)}/>
                                                        </div>
                                                    </div>
                                                </div>
                                            </div>

                                            <div className="col-md-3">
                                                <div className="cm-col">
                                                    <label className="cm-head-label">Combination</label>
                                                    <div className="row custom-disabled-field">
                                                        <div className="col-md-6 ">
                                                            <FormControlLabel control={<Radio color="primary" checked={tarif?.calculationBasis == "AVERAGE"} disabled={disableEdit}/>} label="Average" onChange={()=>commonOnChange('calculationBasis',"AVERAGE")}/>
                                                            <FormControlLabel control={<Radio color="primary" checked={tarif?.calculationBasis == "MAXIMUM"} disabled={disableEdit}/>} label="Maximum" onChange={()=>commonOnChange('calculationBasis',"MAXIMUM")}/>
                                                        </div>
                                                        <div className="col-md-6">
                                                            <FormControlLabel control={<Radio color="primary" checked={tarif?.calculationBasis == "MINIMUM"} disabled={disableEdit}/>} label="Minimum" onChange={()=>commonOnChange('calculationBasis',"MINIMUM")}/>
                                                        </div>
                                                    </div>
                                                </div>
                                            </div>
                                            <div className="col-md-3">
                                                <div className="cm-col">
                                                    {/* <label className="cm-head-label">Credit Card Processing Fees </label> */}
                                                    <div className="row">
                                                        <div className="col-md-12 ">
                                                            <TextField label='Credit Card Processing Fees' className="form-control cm-input autoCapitalise custom-disabled-field " type="text" placeholder="Enter Fees" value={tarif?.ccFeesForTBMerchant} disabled={disableEdit} onChange={(e)=>commonOnChange('ccFeesForTBMerchant',e.target.value)}/>
                                                        </div>
                                                    </div>
                                                </div>
                                            </div>
                                        </div>
                                    </div>
                                </div>

                                <div className="card Tariff__BorderB">
                                    <div className="card-body">
                                        <div className="cm-head-2 mb-4">
                                            <div className="d-flex justify-content-between">
                                                <span className="">Routings</span>
                                            </div>
                                        </div>
                                        <div className="row">
                                            <div className="col-md-3">
                                                <div className="cm-col">
                                                    {/* <label className="cm-head-label">Airport not allowed</label> */}
                                                    <TextField label='Airport not allowed' className="form-control cm-input autoCapitalise custom-disabled-field " type="text" value={tarif?.disallowedAirports?.join()} disabled={disableEdit} onChange={(e)=>commonOnChange('disallowedAirports',[e.target.value.toUpperCase()])}/>
                                                </div>
                                            </div>
                                            {/* <div className="col-md-3">
                                                <div className="cm-col">
                                                    <label className="cm-head-label">Routing field </label>
                                                    <TextField label='' className="form-control cm-input autoCapitalise custom-disabled-field " type="text" value={tarif?.routings} disabled={disableEdit} onChange={(e)=>commonOnChange('routings',e.target.value)}/>
                                                </div>
                                            </div> */}

                                            <div className="col-md-6">
                                                <div className="cm-col mt-1 custom-disabled-field">
                                                    <label className="cm-head-label"></label>
                                                    <FormControlLabel control={<Checkbox color="primary" checked={Boolean(tarif?.skipRoutingCheck)} disabled={disableEdit}/>} label="No Routing Validation By Startrek" onChange={()=>commonOnChange('skipRoutingCheck',!Boolean(tarif?.skipRoutingCheck))}/>
                                                </div>
                                            </div>
                                        </div>
                                    </div>
                                </div>

                                <div className="card ">
                                    <div className="card-body">
                                        <div className="cm-head-2 mb-4">
                                            <div className="d-flex justify-content-between">
                                                <span className="">Distribution</span>
                                            </div>
                                        </div>
                                        <div className="row">
                                            <div className="col-md-3">
                                                <div className="cm-col">
                                                    <label className="cm-head-label">Distribution</label>
                                                    <div className="row custom-disabled-field">
                                                        <div className="col-md-6"><FormControlLabel control={<Checkbox checked={Boolean(tarif?.skyLink)} disabled={disableEdit}/>} label="Sky Link" onChange={()=>commonOnChange('skyLink',!Boolean(tarif?.skyLink))}/></div>
                                                        <div className="col-md-6"><FormControlLabel control={<Checkbox color="primary" checked={Boolean(tarif?.intairTransit)} disabled={disableEdit}/>} label="Intair Transit" onChange={()=>commonOnChange('intairTransit',!Boolean(tarif?.intairTransit))}/> </div>
                                                        <div className="col-md-6"><FormControlLabel control={<Checkbox checked={Boolean(tarif?.funSun)} disabled={disableEdit}/>} label="Fun Sun" onChange={()=>commonOnChange('funSun',!Boolean(tarif?.funSun))}/></div>
                                                        <div className="col-md-6"><FormControlLabel control={<Checkbox color="primary" checked={Boolean(tarif?.DFW)} disabled={disableEdit}/>} label="DFW" onChange={()=>commonOnChange('DFW',!Boolean(tarif?.DFW))}/></div>
                                                        <div className="col-md-6"><FormControlLabel control={<Checkbox color="primary" checked={Boolean(tarif?.sunquest)} disabled={disableEdit}/>} label="Sunquest" onChange={()=>commonOnChange('sunquest',!Boolean(tarif?.sunquest))}/></div>
                                                        <div className="col-md-6"><FormControlLabel control={<Checkbox color="primary" checked={Boolean(tarif?.network)} disabled={disableEdit}/>} label="Network" onChange={()=>commonOnChange('network',!Boolean(tarif?.network))}/></div>
                                                    </div>

                                                </div>
                                            </div>
                                            <div className="col-md-3">
                                                <div className="cm-col custom-disabled-field">
                                                    <label className="cm-head-label">Can not be distributed</label>
                                                    <FormControlLabel control={<Checkbox checked={tarif?.distributionChannels && tarif?.distributionChannels.includes("INTERNAL")} disabled={disableEdit}/>} label="Internal Users" onChange={(e)=>commonOnChange('distributionChannels',tarif?.distributionChannels?.includes("INTERNAL") ? removeItem([...tarif?.distributionChannels], tarif?.distributionChannels.indexOf('INTERNAL')) : addToArrayProperty(tarif, 'distributionChannels', 'INTERNAL'))}/>
                                                    <FormControlLabel control={<Checkbox color="primary" checked={tarif?.distributionChannels && tarif?.distributionChannels.includes("EXTERNAL")} disabled={disableEdit}/>} label="External Users" onChange={(e)=>commonOnChange('distributionChannels',tarif?.distributionChannels?.includes("EXTERNAL") ? removeItem([...tarif?.distributionChannels], tarif?.distributionChannels.indexOf('EXTERNAL')) : addToArrayProperty(tarif, 'distributionChannels', 'EXTERNAL'))}/>
                                                    <FormControlLabel control={<Checkbox color="primary" checked={tarif?.distributionChannels && tarif?.distributionChannels.includes("XML-B2C")} disabled={disableEdit}/>} label="XML - B2C" onChange={(e)=>commonOnChange('distributionChannels',tarif?.distributionChannels?.includes("XML-B2C") ? removeItem([...tarif?.distributionChannels], tarif?.distributionChannels.indexOf('XML-B2C')) : addToArrayProperty(tarif, 'distributionChannels', 'XML-B2C'))}/>
                                                </div>
                                            </div>

                                            <div className="col-md-6">
                                                <div className="cm-col">
                                                    <label className="cm-head-label">PCC DU TARIFF</label>
                                                    <div className='row'>
                                                        <div className="col-md-6">
                                                            {/* <label className="cm-head-label">VIT</label> */}
                                                            <TextField label='VIT' className="cm-input autoCapitalise custom-disabled-field   mb-4" type="text" value={tarif?.pseudoCityCodes} disabled={disableEdit} onChange={(e)=>commonOnChange('pseudoCityCodes',e?.target?.value)}/>
                                                        </div>
                                                        <div className="col-md-6">
                                                            {/* <label className="cm-head-label">FUN</label> */}
                                                            <TextField label='FUN' className="cm-input autoCapitalise custom-disabled-field   mb-4" type="text" value={tarif?.tarifPCC_FUN} disabled={disableEdit} onChange={(e)=>commonOnChange('tarifPCC_FUN',e?.target?.value)}/>
                                                        </div>
                                                        <div className="col-md-6">
                                                            {/* <label className="cm-head-label">SKY</label> */}
                                                            <TextField label='SKY' className="cm-input autoCapitalise custom-disabled-field   mb-4" type="text" value={tarif?.tarifPCC_SKY} disabled={disableEdit} onChange={(e)=>commonOnChange('tarifPCC_SKY',e?.target?.value)}/>
                                                        </div>
                                                        <div className="col-md-6">
                                                            {/* <label className="cm-head-label">TC</label> */}
                                                            <TextField label='TC' className="cm-input autoCapitalise custom-disabled-field   mb-4" type="text" value={tarif?.tarifPCC_TC} disabled={disableEdit} onChange={(e)=>commonOnChange('tarifPCC_TC',e?.target?.value)}/>
                                                        </div>
                                                        <div className="col-md-6">
                                                            {/* <label className="cm-head-label">DFW</label> */}
                                                            <TextField label='DFW' className="cm-input autoCapitalise custom-disabled-field  mb-4" type="text" value={tarif?.tarifPCC_DFW} disabled={disableEdit} onChange={(e)=>commonOnChange('tarifPCC_DFW',e?.target?.value)}/>
                                                        </div>
                                                    </div>
                                                </div>
                                            </div>
                                        </div>
                                    </div>
                                </div>

                                {disableEdit ? null :<Box className="cm-card-edit" sx={{ background: '#C9F7F5', padding: '16px', mb: '0' }}>
                                {updateLoader ? <SpinnerLoader /> :  <><button className="cm-secondary-btn mr-2" type="button" onClick={cancelClick}>Cancel</button>
                                    <button className="cm-primary-btn mr-2" type="button" onClick={()=>saveTariff()}><i className='fa fa-save mr-1'></i> Save</button>
                                    {/* {createNew && <button className="cm-primary-btn" type="button" onClick={()=>createTariffAndNewClass()}> Next</button>} */}
                                    </>}
                                </Box>}
                            </TabPanel>
                            <TabPanel value="2" className='m-0 p-0'>
                                <div className="card ">
                                    <div className="card-body">

                                        <div className="d-flex justify-content-between">
                                            <button onClick={()=>{history.push(`/newClass?tariff=${tarif?.tarifKey}`);dispatch(setClassData([]));}} className="cm-yellow-btn mb-5">+ Create New Class</button>
                                        </div>

                                        {classApiCallLoader?<>...Loading</>:<>{classesArray?.map((classValue)=>{return(<div>
                                            <div className="Tariff_classCard__main" style={{"cursor":"pointer"}} onClick={()=>openClass(classValue, tarif)}>
                                                <div className="Tariff_classCard__Left">
                                                    <div className="Tariff_classCard__alert">
                                                        <span>C</span>
                                                    </div>
                                                    <div className="Tariff_classCard__Right">
                                                        <div className='Tariff_classCard_classOfClass'>
                                                            <span className="Tariff_classCard_mainTitle"> Type: </span>
                                                            <span className="Tariff_classCard_mainTitle"> {classValue?.contractType}</span>
                                                        </div>
                                                        <div className='Tariff_classCard_classOfClass'>
                                                            <span className="Tariff_classCard_subTitle">  Classes: </span>
                                                            <Tooltip placement='top' title={classValue?.classCodes && classValue?.classCodes?.join(",")}><span className="Tariff_classCard_mainTitle">{getClasses(classValue?.classCodes?.join(","))}</span></Tooltip></div>
                                                        <div className='Tariff_classCard_classOfClass'><span className="Tariff_classCard_subTitle"> Brand: </span>
                                                            <span className="Tariff_classCard_mainTitle">{classValue?.brandCode}</span></div>
                                                        <div className='Tariff_classCard_classOfClass'><span className="Tariff_classCard_subTitle"> Category: </span>
                                                            <span className="Tariff_classCard_mainTitle">{classValue?.category}</span></div>
                                                        <div className='Tariff_classCard_classOfClass'><span className="Tariff_classCard_subTitle"> EDR:</span>
                                                            <span className="Tariff_classCard_mainTitle"> {formatToESTDate(classValue?.classLastTicketingDate)}</span>
                                                        </div><div className='Tariff_classCard_classOfClass'><span className="Tariff_classCard_subTitle">Note: </span>
                                                            <span className="Tariff_classCard_mainTitle">{classValue?.classNote}</span></div>
                                                        <div className='Tariff_classCard_classOfClass'><span className="Tariff_classCard_subTitle"> Source:</span>
                                                            <span className="Tariff_classCard_mainTitle">  {classValue?.classCodeDesc}</span>
                                                        </div>
                                                    </div>
                                                </div>
                                            </div>
                                        </div>)})}</>}
                                    </div>
                                </div>
                            </TabPanel>
                        </TabContext>
                    </Box>



                </div>
            </div >
            </div>:null}
        </ >
}
        </>
    )
}

export default NewTariff